export enum USER_STATUS {
  WAIT_FOR_APPROVING = 0,
  SIMPLE_USER = 1,
  MUST_ADD_GUEST = 2,
  MUST_PAY = 3,
  PAYMENT_IN_PROCESS = 4,
  WILL_BE_DELETED = 9,
  LOCKED_BY_ADMIN = 10,
}

export enum USER_ROLES {
  EXPERT,
  JOURNALIST,
}

export interface IGuest {
  id: number;
  user_id: number;
  first_name: string;
  last_name: string;
  title: string;
  company_name: string;
  linkedin: string;
  expertise: Array<{ id: number; name: string }>;
  available: number[];
  country: number[];
  description: string;
  avatar?: string;
  created_at: string;
  updated_at: string;
}
